/* Carrousel « Les Collections »
   Ajouts : defilement au trackpad (mousewheel force sur l'axe
   horizontal), inertie libre, curseur de prehension. */
window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.swiper.collections__container');
  if (!el || typeof Swiper === 'undefined') return;

  new Swiper(el, {
    slidesPerView: 2.33,
    spaceBetween: 5,
    grabCursor: true,
    speed: 550,
    breakpoints: {
      1024: { slidesPerView: 5, spaceBetween: 10 },
      1440: { slidesPerView: 6, spaceBetween: 10 }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    keyboard: { enabled: true },
    mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
    freeMode: { enabled: true, sticky: true, momentumBounce: false }
  });
});
